export default "__VITE_ASSET__ddc68b6a__"